import './App.css';
import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { buildGQLClient } from './graphql/apollo-client';
import AppProvider from './hooks/AppProvider';
import FollowingStateSynchronizer from './hooks/FollowingStateSynchronizer';
import FollowingProvider from './hooks/FollowingProvider';
import { Toaster } from '@fastnorth/kraken/components/toast';
import SessionProvider from './hooks/SessionProvider';

const App = (): ReactElement => (
  <ApolloProvider client={buildGQLClient()}>
    <SessionProvider>
      <AppProvider>
        <FollowingProvider>
          <FollowingStateSynchronizer />
          <Toaster />
          <Outlet />
        </FollowingProvider>
      </AppProvider>
    </SessionProvider>
  </ApolloProvider>
);

export default App;
